import routerTrainings from "../modules/trainings/core/trainings-router"
import routerTrainingChapterCategories from "../modules/training-chapter-categories/core/chapter-category-router"
import routerExams from "../modules/exams/core/exams-router"
import routerUsers from "../modules/users/core/users-router"
import routerPayments from "../modules/payments/core/payments-router"
import ExerciseLayout from "../Exercise-layout.vue"
import ROUTE_NAMES from "@/app/exercise/router/router-const";

export default {
  path: '',
  component: ExerciseLayout,
  redirect: { name: ROUTE_NAMES.TRAININGS },
  children: [
    ...routerTrainings,
    ...routerTrainingChapterCategories,
    ...routerExams,
    ...routerUsers,
    ...routerPayments,
  ],
  meta: {
    requiresAuth: true
  }
}
